(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zentus-legal-guarantee"] && !Shopify.designMode) return;
  try {
    class ZentusLegalGuarantee extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-guarantee-open]');
      if (!dialog?.showModal || !trigger) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const content = this.querySelector('[data-guarantee-content]');
      const select = (language) => {
        const template = this.querySelector(`template[data-language="${language}"]`);
        if (!template) return;
        content.replaceChildren(template.content.cloneNode(true));
        this.querySelectorAll('[data-guarantee-language]').forEach((link) => {
          if (link.dataset.guaranteeLanguage === language) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };
      const modified = (event) => event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        if (modified(event)) return;
        event.preventDefault();
        if (dialog.open) return;
        select(this.dataset.primaryLanguage);
        dialog.showModal();
        content.querySelector('[data-notice-heading]')?.focus();
      }, options);
      this.querySelector('[data-guarantee-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); dialog.close(); }, options);
      dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus(); }, options);
      this.querySelectorAll('[data-guarantee-language]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (modified(event)) return;
          event.preventDefault();
          select(link.dataset.guaranteeLanguage);
          content.querySelector('[data-notice-heading]')?.focus();
        }, options);
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('zentus-legal-guarantee')) customElements.define('zentus-legal-guarantee', ZentusLegalGuarantee);
  } catch(e) { console.error(e); }
})();

})();
